export default "__VITE_ASSET__B10wCxx1__"